export const EMAIL_REGEX = /^[a-z0-9.!#$%&'*+-/=?^_`{|}~]+@[a-z0-9-]+(?:\.[a-z0-9-]+)+$/;